export default "__VITE_ASSET__D_ETvf6X__"